
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ChallengesSection from './components/ChallengesSection';
import ProcessSection from './components/ProcessSection';
import BenefitsSection from './components/BenefitsSection';
import PaperworkSection from './components/PaperworkSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function InheritedHomesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell Inherited House El Paso | We Buy Inherited Properties for Cash"
        description="Inherited a house in El Paso? We buy inherited homes fast for cash, even with probate issues. No repairs, no cleaning, no hassle. Get your fair cash offer today."
        keywords="sell inherited house El Paso, inherited property buyers, probate house sale, sell house after death, inherited home cash buyers"
        canonical="/inherited-homes"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Inherited Home Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <ChallengesSection />
      <ProcessSection />
      <BenefitsSection />
      <PaperworkSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
